import { useNavigate } from 'react-router-dom';
import { Paragraph, Select } from '@quickmd-llc/design-system';
import {
  BOOKING_CONFIRMATION_ROUTE_PATHNAME,
  COMPLETE_BOOKING_ROUTE_PATHNAME,
  COMPLETE_PROFILE_ROUTE_PATHNAME,
} from '@router/routes/routePathnames';
import { PHONE_ROUTE_ID } from '@constants/routeIds';

export function RouteSelect() {
  const navigate = useNavigate();
  function handleChange({
    currentTarget,
  }: React.ChangeEvent<HTMLSelectElement>) {
    const { value } = currentTarget;

    navigate(value);
  }

  return (
    <div>
      <Paragraph size="xs" className="mb-1 font-semibold">
        Select Route
      </Paragraph>

      <Select onChange={handleChange} placeholder="Select Route">
        <option value={COMPLETE_PROFILE_ROUTE_PATHNAME}>
          Complete Profile
        </option>
        <option value={BOOKING_CONFIRMATION_ROUTE_PATHNAME}>
          Booking Confirmation
        </option>
        <option value={COMPLETE_BOOKING_ROUTE_PATHNAME}>
          Complete Booking
        </option>
        <option value={PHONE_ROUTE_ID}>Verify Phone</option>
      </Select>
    </div>
  );
}
